import { Switch } from '@material-ui/core';
import type {
  UserPreferencesData,
  UserPreferencesUpdateData,
  UserProfileUpdateData,
} from '@mogul/api-client';
import { useState } from 'react';
import { toast } from 'react-hot-toast';

import styles from './Notifications.module.css';

interface Props {
  loading: boolean;
  handleEmailNotify: (data: UserPreferencesUpdateData) => void;
  onUpdateProfile: (data: UserProfileUpdateData) => Promise<void>;
  preferences: UserPreferencesData;
}

export const NotificationsComponent: React.FC<Props> = props => {
  const { handleEmailNotify, preferences } = props;
  const [dropConsent, setDropConsent] = useState(
    preferences.dropNotifyConsent ?? false,
  );

  const [emailNotifs, setEmailNotifs] = useState(
    preferences.emailNotifs ?? false,
  );

  // const [emailConsent, setEmailConsent] = useState(
  //   preferences.emailNotifs ?? false,
  // );

  const handleDropChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    try {
      handleEmailNotify({ ...preferences, dropNotifyConsent: !dropConsent });
      setDropConsent(event.target.checked);
    } catch (e) {
      toast.error('An error occurred, try again later');
    }
  };

  const handleEmailNotifsChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    try {
      handleEmailNotify({ ...preferences, emailNotifs: !emailNotifs });
      setEmailNotifs(event.target.checked);
    } catch (e) {
      toast.error('An error occurred, try again later');
    }
  };

  // const handleNewsletterChange = (
  //   event: React.ChangeEvent<HTMLInputElement>,
  // ) => {
  //   try {
  //     handleEmailNotify({ ...preferences, emailNotifs: !emailNotifs });
  //     setEmailConsent(event.target.checked);
  //   } catch (e) {
  //     toast.error('An error occurred, try again later');
  //   }
  // };

  return (
    <div className={`${styles.outerContainer}`}>
      <div className={styles.profileHeader}>
        <h1 className={styles.heading}>your notifications</h1>
      </div>
      <div className={`${styles.profileInfoContainer} justify-center`}>
        <div className={`flex flex-col flex-wrap px-10 w-full`}>
          {/* <div className="flex flex-row justify-between align-center py-5">
            <div className={styles.notifHeaders}>Email Newsletters</div>
            <Switch
              checked={emailConsent}
              onChange={handleNewsletterChange}
              inputProps={{ 'aria-label': 'controlled' }}
              color="primary"
              size="medium"
            />
          </div> */}

          <div className="flex flex-row justify-between align-center py-5">
            <div className={styles.notifHeaders}>Marketplace Actions</div>
            <Switch
              checked={emailNotifs}
              onChange={handleEmailNotifsChange}
              inputProps={{ 'aria-label': 'controlled' }}
              color="primary"
              size="medium"
            />
          </div>

          <div className="flex flex-row justify-between align-center py-5">
            <div className={styles.notifHeaders}>
              New Digital Collectibles Drops
            </div>
            <Switch
              checked={dropConsent}
              onChange={handleDropChange}
              inputProps={{ 'aria-label': 'controlled' }}
              color="primary"
              size="medium"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
